import { createFileRoute, useNavigate } from '@tanstack/react-router';
import {
  dashboardParamsSchema,
  dashboardQueries,
  type DashboardParams,
} from '@/entities/dashboard';
import { DashboardPage } from '@/pages/dashboard';

export const Route = createFileRoute('/')({
  staticData: { permission: 'dashboard.view' },
  validateSearch: dashboardParamsSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => {
    void context.queryClient
      .prefetchQuery(dashboardQueries.summary(deps))
      .catch(() => undefined);
  },
  component: DashboardRoute,
});

function DashboardRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const onParamsChange = (next: Partial<DashboardParams>) => {
    void navigate({
      search: (prev) => ({
        ...prev,
        ...next,
      }),
    });
  };

  return <DashboardPage params={search} onParamsChange={onParamsChange} />;
}
